import React, { Component } from 'react';
import { reduxForm, Field, getFormValues, reset } from 'redux-form';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import PropTypes from 'prop-types';

import { createServiceAction } from '../../../util/actionHelper.js';
import { H4, H5, TextInput, Button, IconButton, DropDown, Spinner, ConfirmationBox } from '../../../components/index.js';
import { toggleAddSupplerButton, litmosCheckBoxValue } from '../../../actions/navigationActions.js';
import SupplierSearch from '../../supplierSearch/SupplierSearch.js';
import {
  getSupplierList,
} from '../../../reducers/authReducer.js';
import PdfPreview from '../../../util/PdfPreview.js';
if (process.env.NODE_ENV !== 'test') Modal.setAppElement('#app-host');

function getCountryOptions(labLocationCountries) {
  return (labLocationCountries || []).map(countryEntry => ({
    id: countryEntry.country,
    value: countryEntry.country,
    label: countryEntry.country
  }));
}

function getLabLocationSelectionValue(labId, locationId) {
  if (labId && locationId) {
    return `${labId}::${locationId}`;
  }
  return locationId;
}

function parseLabLocationSelection(selectedValue, fallbackLabId = null) {
  if (selectedValue === null || typeof selectedValue === 'undefined' || selectedValue === '') {
    return { labId: fallbackLabId, labLocationId: null };
  }
  const normalized = String(selectedValue);
  if (normalized.includes('::')) {
    const [labId, labLocationId] = normalized.split('::');
    return {
      labId: labId ? Number(labId) : fallbackLabId,
      labLocationId: labLocationId ? Number(labLocationId) : null
    };
  }
  return {
    labId: fallbackLabId,
    labLocationId: Number(normalized)
  };
}

function getLabLocations(labLocationCountries, selectedCountry) {
  if (selectedCountry) {
    const selectedCountryData = (labLocationCountries || []).find(
      countryEntry => countryEntry.country === selectedCountry
    );
    return (selectedCountryData && selectedCountryData.location ? selectedCountryData.location : [])
      .map(locationEntry => ({
        id: locationEntry.id,
        value: getLabLocationSelectionValue(locationEntry.labId, locationEntry.id),
        label: `${locationEntry.lab || ''}, ${locationEntry.area || ''}`.replace(/^,\s*|\s*,\s*$/g, '')
      }));
  }
  return [];
}

function getLabLocationById(labLocationCountries, selectedLocationId, selectedLabId) {
  const parsed = parseLabLocationSelection(selectedLocationId, selectedLabId);
  const effectiveLocationId = parsed.labLocationId;
  const effectiveLabId = parsed.labId;
  const allLocations = (labLocationCountries || []).flatMap(countryEntry =>
    (countryEntry.location || []).map(locationEntry => ({
      ...locationEntry,
      country: countryEntry.country
    }))
  );
  if (effectiveLabId) {
    const locationByLabAndLocationId = allLocations.find(
      locationEntry => String(locationEntry.id) === String(effectiveLocationId)
        && String(locationEntry.labId) === String(effectiveLabId)
    );
    if (locationByLabAndLocationId) {
      return locationByLabAndLocationId;
    }
  }
  return allLocations.find(locationEntry => String(locationEntry.id) === String(effectiveLocationId));
}

function emailValidate(value) {
  let isValidEmail = false;
  if (value) {
    isValidEmail = value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
      ? false
      : true
  }
  return isValidEmail;
}

class EditUserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isValidEmail: false,
      isUpdated:false,
      oshUpdate:false,
      oshIdArr:[],
      litmosUpdate:false,
      submitModal: false,
      selectedFileName:"",
      modalIsOpen: false,
      selectedFile: null,
      previewSpinner: false,
      filePreviews: [],
      uploadedFiles: [],
      osIdModalOpen: false,
      osIdState: '',
      trainingCerAttachments: [],
      trainingCerModalOpen: false,
      isSelectedFile:"",
      isSelectedFileID:"",
      isDeletedFiles:[],
      litmosCheckboxstate: false,
      showLitmosError:false,
      trainingMaterialModalOpen: false,
      trainingMaterialDeleted: false
    };
    this.submitAddUserData = this.submitAddUserData.bind(this);
    this.updateAddUserData = this.updateAddUserData.bind(this)
  }

  componentDidMount() {
    const {
      toggleAddSupplerButton,
      editUserProfileStates
    } = this.props;
    toggleAddSupplerButton();
    // Reset state variables
    this.setState({
      isValidEmail: false,
      isUpdated: false,
      oshUpdate: false,
      oshIdArr: [],
      litmosUpdate: false,
      submitModal: false,
      selectedFileName: "",
      modalIsOpen: false,
      selectedFile: null,
      previewSpinner: false,
      filePreviews: [],
      uploadedFiles: [],
      osIdModalOpen: false,
      osIdState: '',
      trainingCerAttachments: [], 
      trainingCerModalOpen: false,
      isSelectedFile: "",
      isSelectedFileID: "",
      isDeletedFiles: [],
      litmosCheckboxstate: false,
      trainingMaterialModalOpen: false,
      trainingMaterialDeleted: false
    }, () => {
      // Initialize osIdState if available
      if (editUserProfileStates && editUserProfileStates.OSHId) {
        this.setState({ osIdState: editUserProfileStates.OSHId });
      }
      
      // Properly initialize trainingCerAttachments from props
      this.initializeTrainingAttachments(editUserProfileStates);
      
      // Set initial litmos checkbox based on litmosStatus
      this.updateLitmosCheckboxBasedOnStatus(editUserProfileStates);
    });
  }

  // New helper method to manage litmos checkbox state
  updateLitmosCheckboxBasedOnStatus = (profileData) => {
    const {litmosCheckBoxValue} = this.props;
    const { isDeletedFiles } = this.state;
    if (!profileData) return;
    const hasDeletedFiles = isDeletedFiles && isDeletedFiles.length > 0;
    
    if (profileData.litmosStatus === "completed" && !hasDeletedFiles) {
      this.setState({ litmosUpdate: true });
      litmosCheckBoxValue(true);
    } else {
      this.setState({ litmosUpdate: false });
      litmosCheckBoxValue(false);
    }
  }

  // Add a new method to handle initialization of training attachments
  initializeTrainingAttachments(profileData) {
    this.setState({ 
      trainingCerAttachments: [],
      uploadedFiles: []
    });
    
    if (profileData && profileData.litmos && profileData.litmos.attachmentData) {
      let attachments = [];
      if (typeof profileData.litmos.attachmentData === 'string') {
        attachments = [profileData.litmos.attachmentData];
      } else if (Array.isArray(profileData.litmos.attachmentData)) {
        attachments = profileData.litmos.attachmentData.map(item => {
          if (typeof item === 'string') {
            return item;
          } else if (typeof item === 'object') {
            return item;           }
          return '';
        });
      }
      
      this.setState({ 
        trainingCerAttachments: attachments,
        uploadedFiles: profileData.litmos.fileNames || []
      });
    }
  }
  
  componentDidUpdate(prevProps) {
    const {
      editUserProfileStates,
      previewAttachmentData,
      labLocationCountries,
      change
    } = this.props;
    const { modelState , uploadedFiles} = this.state;

    // Debug: Log Training Material Status when user data changes
    if (editUserProfileStates && editUserProfileStates !== prevProps.editUserProfileStates) {
      console.log('EditUserProfile - User Data:', {
        TrainingMaterialStatus: editUserProfileStates.TrainingMaterialStatus,
        OSHStatus: editUserProfileStates.OSHStatus,
        litmosStatus: editUserProfileStates.litmosStatus,
        userType: editUserProfileStates.userType
      });
    }

    // Update osIdState when editUserProfileStates.OSHId changes
    if (editUserProfileStates && editUserProfileStates.OSHId !== prevProps.editUserProfileStates.OSHId) {
      this.setState({ osIdState: editUserProfileStates.OSHId || '' });
    }
    // Check for changes in litmos attachment data and update state
    if (
      editUserProfileStates && 
      editUserProfileStates.litmos &&
      prevProps.editUserProfileStates && 
      prevProps.editUserProfileStates.litmos &&
      JSON.stringify(editUserProfileStates.litmos) !== JSON.stringify(prevProps.editUserProfileStates.litmos)
    ) {
      this.initializeTrainingAttachments(editUserProfileStates);
    }

    // If this is the first time editUserProfileStates is available with litmos data
    if (
      editUserProfileStates && 
      editUserProfileStates.litmos && 
      (!prevProps.editUserProfileStates || !prevProps.editUserProfileStates.litmos)
    ) {
      this.initializeTrainingAttachments(editUserProfileStates);
    }
    if (
      editUserProfileStates &&
      editUserProfileStates.litmos &&
      Array.isArray(editUserProfileStates.litmos.fileNames)
    ) {
      if (
        editUserProfileStates.litmos.fileNames.length > 0 &&
        (
          !uploadedFiles ||
          JSON.stringify(uploadedFiles) !== JSON.stringify(editUserProfileStates.litmos.fileNames)
        )
      ) {
        this.setState({ uploadedFiles: editUserProfileStates.litmos.fileNames });
      }
    }
    if (editUserProfileStates && editUserProfileStates.userId && editUserProfileStates.userId !== "") {

      if (!modelState) {
        this.setState({ modelState: true });
      }

    } else {
      if (modelState) {
        this.setState({ modelState: false });
      }
    }
    
    if(editUserProfileStates && prevProps.editUserProfileStates && editUserProfileStates!== prevProps.editUserProfileStates &&
       (prevProps.editUserProfileStates.userId === editUserProfileStates.userId ||
       (prevProps.editUserProfileStates.email === editUserProfileStates.email && this.emailValidate(editUserProfileStates.email))) ){
      this.setState({isUpdated:true})
    }
    
    if(editUserProfileStates && (editUserProfileStates.userType === 'Suppliers' ||
      editUserProfileStates.userType === 'Factories') &&
        prevProps.editUserProfileStates && prevProps.editUserProfileStates.OSIds !== editUserProfileStates.OSIds &&
        editUserProfileStates.OSIds && editUserProfileStates.OSIds[0] !== null && editUserProfileStates.OSIds[0] !== undefined){
        this.setState({oshIdArr:editUserProfileStates.OSIds,filteredSupp:editUserProfileStates.OSIds})
      }
      
    if (previewAttachmentData !== prevProps.previewAttachmentData && previewAttachmentData && Object.keys(previewAttachmentData).length > 0) {
      let content = previewAttachmentData.data.Content;
      this.setState({ selectedFile: 'data:application/pdf;base64,' + content, modalIsOpen: true, previewSpinner: false });
    }

    // Set litmosUpdate to true if litmosStatus is "completed"
    if (
      editUserProfileStates && 
      prevProps.editUserProfileStates &&
      editUserProfileStates.litmosStatus === "completed"
    ) {
      litmosCheckBoxValue(true);
      }

    if (
      editUserProfileStates &&
      editUserProfileStates.userType === 'Labs' &&
      editUserProfileStates.labLocationId &&
      !editUserProfileStates.country &&
      labLocationCountries &&
      labLocationCountries.length > 0
    ) {
      const selectedLabLocation = getLabLocationById(
        labLocationCountries,
        editUserProfileStates.labLocationId,
        editUserProfileStates.labId
      );
      if (selectedLabLocation) {
        if (
          selectedLabLocation.country
          && editUserProfileStates.country !== selectedLabLocation.country
        ) {
          change('country', selectedLabLocation.country);
        }
        if (String(editUserProfileStates.labLocationId) !== String(selectedLabLocation.id)) {
          change('labLocationId', getLabLocationSelectionValue(selectedLabLocation.labId, selectedLabLocation.id));
        }
      }
    }
    if (
      editUserProfileStates &&
      editUserProfileStates.userType === 'Labs' &&
      editUserProfileStates.country &&
      editUserProfileStates.labId &&
      editUserProfileStates.labLocationId &&
      !String(editUserProfileStates.labLocationId).includes('::')
    ) {
      change(
        'labLocationId',
        getLabLocationSelectionValue(editUserProfileStates.labId, editUserProfileStates.labLocationId)
      );
    }
  }

  submitAddUserData = () => {
    const { submitUserProfile, editUserProfileStates, labLocationCountries } = this.props;
    const reqObj = {};
    reqObj.name = editUserProfileStates.userName || '';
    reqObj.email = editUserProfileStates.email || '';
    if (editUserProfileStates.userType === 'Suppliers' || editUserProfileStates.userType === 'Factories') {
      reqObj.supplierName = editUserProfileStates.supplierName ;
      reqObj.supplierOrLocationId = editUserProfileStates.supplierOrLocationId;
    } else {
      const selectedLabLocation = getLabLocationById(
        labLocationCountries,
        editUserProfileStates.labLocationId,
        editUserProfileStates.labId
      );
      reqObj.labId = selectedLabLocation ? selectedLabLocation.labId : '';
      reqObj.supplierOrLocationId = parseLabLocationSelection(
        editUserProfileStates.labLocationId,
        editUserProfileStates.labId
      ).labLocationId;
    }
    reqObj.compBAddr = "";
    reqObj.contact = editUserProfileStates.contact;
    reqObj.userType = editUserProfileStates.userType;
    this.setState({isUpdated:false, modelState:false})
    submitUserProfile(reqObj);
  }

  updateAddUserData = (e) => {
    const { updateUserProfile, editUserProfileStates, labLocationCountries } = this.props;
    const { oshUpdate, litmosUpdate, isDeletedFiles, osIdState, trainingMaterialDeleted}= this.state;
    const resultArray = {};
    resultArray.name = editUserProfileStates.userName ;
    resultArray.email = editUserProfileStates.email ;
    resultArray.userID = editUserProfileStates.userId;
    resultArray.userType = editUserProfileStates.userType;
    resultArray.supplierName = (editUserProfileStates.userType === 'Suppliers') || (editUserProfileStates.userType === 'Factories') ? editUserProfileStates.supplierName : '';
    resultArray.supplierOrLocationId = (editUserProfileStates.userType === 'Suppliers') || (editUserProfileStates.userType === 'Factories') ?

      editUserProfileStates.supplierOrLocationId?editUserProfileStates.supplierOrLocationId:editUserProfileStates.supplierId
      : parseLabLocationSelection(editUserProfileStates.labLocationId, editUserProfileStates.labId).labLocationId;
    resultArray.contact = editUserProfileStates.contact;
    if (editUserProfileStates.userType === 'Labs') {
      const selectedLabLocation = getLabLocationById(
        labLocationCountries,
        editUserProfileStates.labLocationId,
        editUserProfileStates.labId
      );
      resultArray.labId = selectedLabLocation ? selectedLabLocation.labId : null;
    } else {
      resultArray.labId = null;
    }
    if(editUserProfileStates.OSHStatus !== "completed"){
      resultArray.osh = oshUpdate;
    }
    resultArray.OSHId = editUserProfileStates.OSHId;
    if(editUserProfileStates.userType === 'Factories' ||editUserProfileStates.userType === 'Suppliers'){
    let locIdarr = [];
    const { oshIdArr } = this.state;
    oshIdArr.filter(entry => locIdarr.push(entry.locId));
    resultArray.locIds=locIdarr;
    }
    if(editUserProfileStates.litmosStatus !== "completed"){
      resultArray.litmos = litmosUpdate;
    }
    if(isDeletedFiles && isDeletedFiles.length >0){
      resultArray.litmos = false;
    }
    if (litmosUpdate) {
      resultArray.litmos = true;
    }
    if(osIdState === ''){
      resultArray.OSHId = null;
      resultArray.osIdDeleted = true;
    }
    if(isDeletedFiles && isDeletedFiles.length>0){
      resultArray.deletedAttachments = isDeletedFiles;
    }
    if(trainingMaterialDeleted){
      resultArray.trainingMaterial = false;  // Send false to reset status to 'pending'
    }
    this.setState({isUpdated:false,oshUpdate:false,litmosUpdate:false, trainingMaterialDeleted:false, modelState:false})
    updateUserProfile(resultArray);
 }

  emailValidate = (value) => {
    let isValidEmail = false;
    if (value) {
      isValidEmail = value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? false
        : true
    }
    return isValidEmail;
  }

  shouldEnableSubmit = () => {
    const { editUserProfileStates, supplierStates } = this.props;

    if (editUserProfileStates) {
      if ((editUserProfileStates.userType === 'Suppliers' || editUserProfileStates.userType === 'Factories')&& supplierStates ) {
        return !!(editUserProfileStates.userName && this.emailValidate(editUserProfileStates.email));
      }
      else if (editUserProfileStates.userType === 'Labs') {
        return !!(editUserProfileStates.userName && this.emailValidate(editUserProfileStates.email) &&
          editUserProfileStates.country && editUserProfileStates.labLocationId && editUserProfileStates.contact);
      } else if (editUserProfileStates.userType === '') {
        return false;
      }
    }
    return false;
  };

  shouldEnableUpdate = () => {
    const { editUserProfileStates } = this.props;
    const { isUpdated,litmosUpdate,oshUpdate } = this.state;
    if (editUserProfileStates) {
      if((editUserProfileStates.userType === 'Suppliers' || editUserProfileStates.userType === 'Factories')&& isUpdated)
      {
        return !!(editUserProfileStates.userName && this.emailValidate(editUserProfileStates.email));
      }
      else if (editUserProfileStates.userType === 'Labs' && isUpdated) {
        return !!(editUserProfileStates.country && editUserProfileStates.labLocationId && editUserProfileStates.contact
          && editUserProfileStates.userName && this.emailValidate(editUserProfileStates.email));
      }
      else if (editUserProfileStates.userType === '') {
        return false;
      }
      else if(oshUpdate || litmosUpdate){
        return true
      }
    }
    return false;
  }
  onSupplierChange=(name,id) =>{
    const { change } = this.props;
     change('supplierName', name ? name : '');
    change('supplierOrLocationId', id? id : '');
    this.setState({isUpdated:true})
  }
  onCountryChange = () => {
    const { change } = this.props;
    change('labLocationId', null);
    change('labId', null);
    this.setState({ isUpdated: true });
  }
  onLabLocationChange = (selectedLabLocationValue) => {
    const { change, labLocationCountries, editUserProfileStates } = this.props;
    const selectedLabLocation = getLabLocationById(
      labLocationCountries,
      selectedLabLocationValue,
      editUserProfileStates && editUserProfileStates.labId
    );
    if (selectedLabLocation) {
      change('labId', selectedLabLocation.labId);
      change('labLocationId', getLabLocationSelectionValue(selectedLabLocation.labId, selectedLabLocation.id));
    } else {
      change('labLocationId', selectedLabLocationValue);
    }
    this.setState({ isUpdated: true });
  }
  onOSIdChange=(OSHId)=>{
    var filtered=[];
    const { oshIdArr, filteredSupp } = this.state;
    if (oshIdArr.length === 0) {
      const { supplierList } = this.props;
      filtered = (supplierList || []).filter(function(el) { return el.OSId !== OSHId; });
    } else {
      filtered = filteredSupp.filter(function(el) { return el.OSId !== OSHId; });
    }
   this.setState({oshIdArr:[...oshIdArr,OSHId],isUpdated:true,filteredSupp:filtered})
  }

  toggleModal = (status) => {

    const { toggleModal } = this.props;
    const { trainingCerAttachments } = this.state;

    toggleModal(status);

    this.setState({
      modelState: status,
      oshUpdate: false,
      isUpdated: false,
      oshIdArr: [],
      trainingCerAttachments: status ? trainingCerAttachments : [], 
      isDeletedFiles: [],
      litmosCheckboxstate: false,
      litmosUpdate: false,
      showLitmosError:false,
      showOsIdError:false,
    });
  }
  handleOSH=(e)=>{
    const isChecked = e.target.checked;
    const { osIdState } = this.state;
    if(osIdState !== ''){
    this.setState({
    oshUpdate: isChecked,
    isUpdated: true,
    showOsIdError:false,
    });

    // If you need to update any form values
    const { change } = this.props;
    if (change) {
    change('osh', isChecked);
    }}else{
      this.setState({showOsIdError:true})
    }
  }
  handleLitmos = (e) => { 
  const { litmosCheckBoxValue} = this.props;
  const { trainingCerAttachments } = this.state;
  const isChecked = e.target.checked;
  if(trainingCerAttachments && trainingCerAttachments.length > 0){
  this.setState({
    litmosUpdate: isChecked,
    isUpdated: true,
    litmosCheckboxstate: isChecked,
    showLitmosError:false
  });
  if (typeof litmosCheckBoxValue === 'function') {
    litmosCheckBoxValue(isChecked);
  }
}else{
  this.setState({showLitmosError:true})
}
}
  handleRemoveClick = (index) => {
    const { oshIdArr } = this.state;
    oshIdArr.splice(index, 1);
    this.setState({ oshIdArr, isUpdated: true });
    this.setState(({ oshIdArr }) => ({
      oshIdArr,
      isUpdated: true
    }));
  };
  handleOSHIDChange =(e,i)=>{
    const { oshIdArr: list } = this.state;
    list[i] = e.target.value;
    this.setState({oshIdArr : list})
  }
  downloadFile = (requestParams) => {
    const { editUserProfileStates,previewAttachment } = this.props;
    previewAttachment({ ...requestParams, formType: 'trainingCertificate',userId: editUserProfileStates.userId, for: 'download' });
  }
  previewFile = (requestParams) => {
      const { previewAttachment, editUserProfileStates } = this.props;
      this.setState({ previewSpinner: true }); // Set loading to true
      previewAttachment({ ...requestParams, formType: 'trainingCertificate',userId: editUserProfileStates.userId, for: 'preview' });
  }
//   componentDidUpdate(prevProps) {
//     const { previewAttachmentData } = this.props;
//     if (previewAttachmentData !== prevProps.previewAttachmentData && previewAttachmentData && Object.keys(previewAttachmentData).length > 0) {
//         let content = previewAttachmentData.data.Content;
//         this.setState({ selectedFile: 'data:application/pdf;base64,' + content, modalIsOpen: true, previewSpinner: false });
//     }
// }
  closeModal = () => {
    this.setState({ modalIsOpen: false,selectedFile: null, showOsIdError:false, showLitmosError:false });
}
  openConfirmationPopup = (item)=> {
    this.setState({submitModal: true,selectedFileName:item});
  }
  closeSubmitModal = () => {
    this.setState({submitModal: false, osIdModalOpen: false, trainingCerModalOpen: false, trainingMaterialModalOpen: false  });
  };
  handleDelete = (index) => {
     const {  trainingCerAttachments } = this.state;
     const deletedFileName = trainingCerAttachments[index].fileName;
     const deletedFileID = trainingCerAttachments[index].attachmentId;
     this.setState({isSelectedFile:deletedFileName,isSelectedFileID:deletedFileID, trainingCerModalOpen: true});
    
  }

  handleDeleteOsId = (item) => {
    this.setState({osIdModalOpen: true});
  }

  onHandleOkDeleteOshId = (id) => {
    const {  change } = this.props;
    this.setState({ osIdModalOpen: false, osIdState: '', oshUpdate: false, isUpdated: true });
    change('osIdDeleted', '');
  }

  handleDeleteTrainingMaterial = () => {
    this.setState({ trainingMaterialModalOpen: true });
  }

  onHandleOkDeleteTrainingMaterial = () => {
    this.setState({ trainingMaterialModalOpen: false, trainingMaterialDeleted: true, isUpdated: true });
  }

  handleDeleteTrainingCertificate = (fileName, fileId) => {
    const { trainingCerAttachments, isDeletedFiles, litmosUpdate} = this.state;
    const { editUserProfileStates } = this.props;
    
    const updatedDeletedFiles = [...isDeletedFiles];
    if (fileName && fileId) {
      updatedDeletedFiles.push({ fileName, fileId });
    }
    
    const updatedAttachments = trainingCerAttachments.filter(item => {
      if (typeof item === 'object' && item !== null) {
        const itemFileName = item.fileName || item.attachmentName || '';
        const itemFileId = item.attachmentId || item.fileId || '';
        return !(itemFileName === fileName && String(itemFileId) === String(fileId));
      }
      return item !== fileName;
    });
    
    // If we're deleting files and status was "completed", update checkbox to false
    const shouldUpdateLitmos = editUserProfileStates && 
                            editUserProfileStates.litmosStatus === "completed" && 
                            updatedDeletedFiles.length > 0;
    
    this.setState({
      trainingCerAttachments: updatedAttachments,
      trainingCerModalOpen: false,
      isSelectedFile: "",
      isSelectedFileID: "",
      isUpdated: true,
      isDeletedFiles: updatedDeletedFiles,
      litmosUpdate: shouldUpdateLitmos ? false : litmosUpdate,
      litmosCheckboxstate: false
    }, () => {
      if (shouldUpdateLitmos) {
       litmosCheckBoxValue(false);
      }
    });
  }
    render() {
    const { isModalOpen,
      toggleModal,
      editUserProfileStates,
      clearUserDetailsFilled,
      isAdd,
      getLitmosCheckboxValue,
      labLocationCountries
    } = this.props;
    
    const { oshIdArr, submitModal, selectedFileName, selectedFile, modalIsOpen, previewSpinner, modelState, osIdModalOpen,
      osIdState , trainingCerAttachments, trainingCerModalOpen,
      isDeletedFiles,litmosUpdate, litmosCheckboxstate,oshUpdate, isSelectedFile, isSelectedFileID, showLitmosError, showOsIdError,
      trainingMaterialModalOpen, trainingMaterialDeleted} = this.state;
    const displaySupplier = ((editUserProfileStates && editUserProfileStates.userType === 'Suppliers'));
    const displayFactory = ((editUserProfileStates && editUserProfileStates.userType === 'Factories'));
    const displayLab = ((editUserProfileStates && editUserProfileStates.userType === 'Labs'));
    const oshStatus = editUserProfileStates && editUserProfileStates.OSHStatus === "completed" && osIdState !== '' ? true : false;
    const trainingMaterialStatus = editUserProfileStates && editUserProfileStates.TrainingMaterialStatus && 
      editUserProfileStates.TrainingMaterialStatus.toLowerCase() === "completed" && !trainingMaterialDeleted;
   const displaySupplierSearch = editUserProfileStates && editUserProfileStates.supplierName !== null && editUserProfileStates.supplierName !== undefined;
   return (
      <span>
        {
          (!isAdd && !editUserProfileStates) ?
            <Spinner large />
            :
            <Modal
            isOpen={(modelState && !isAdd) ? true : (!modelState && isModalOpen) ? true : false}
            onRequestClose={() => { this.toggleModal(false); clearUserDetailsFilled() }}
            className="modal-container edit-user-modal-container"
            overlayClassName="modal-overlay"
            >
              <IconButton icon="times" className="modal-close-btn" onClick={() => { this.toggleModal(false); clearUserDetailsFilled() }} />
              <form className="form">
                <div className="p2-sm">
                  <H4 className="text-color-accent u-bold page-title-has-back sub-heading">{isAdd ? 'ADD USER DETAILS' : 'EDIT USER DETAILS'}</H4>
                </div>
                <div>
                  <div className="ncss-col-sm-12">
                    {editUserProfileStates && editUserProfileStates.email && !this.emailValidate(editUserProfileStates.email) ?
                      <div className="ncss-col-sm-12 ncss-input-container ">
                        <H5 className="ncss-col-sm-12 text-color-accent u-bold description p2-top-sm p2-bottom-sm">{`Please enter valid email address`}</H5>
                      </div> : null
                    }
                    <div className="ncss-col-sm-12 ncss-input-container ">
                      <H5 className="ncss-col-sm-3 u-bold description p2-top-sm p2-bottom-sm">Name</H5>

                      <div className="ncss-col-sm-9"> <Field component={TextInput} name="userName" type="text" /></div>
                    </div>
                    <div className="ncss-col-sm-12 ncss-input-container ">
                      <H5 className="ncss-col-sm-3 u-bold description p2-top-sm p2-bottom-sm">E-Mail</H5>
                      <div className="ncss-col-sm-9"> <Field component={TextInput} name="email" type="text"
                        validate={emailValidate}
                      /></div>
                    </div>
                    <div className="ncss-col-sm-12 ncss-input-container">
                      <H5 className="ncss-col-sm-3 u-bold description p2-top-sm p2-bottom-sm">User Type</H5>
                      <div className="ncss-col-sm-9">
                        <span className="dropdown-add-supplier">
                          <Field
                            component={DropDown}
                            placeholder="Select a user"
                            options={[{ id: 'lab', value: 'Labs', label: 'Lab' },
                            { id: 'supplier', value: 'Suppliers', label: 'Supplier' },
                            { id: 'factory', value: 'Factories', label: 'Factory' }]}
                            name="userType"
                          />
                        </span>
                      </div>
                    </div>
                    {
                      displaySupplier || displayFactory ?
                      <>
                        <div className="ncss-col-sm-12 ncss-input-container ">
                          <H5 className=" ncss-col-sm-3 u-bold description p2-top-sm p2-bottom-sm"> PCX Supplier Search</H5>
                          <div className="ncss-col-sm-9">
                            <SupplierSearch
                              includeInternal={false}
                              includePCX={true}
                              requsetLocation={false}
                              supplierChange = { this.onSupplierChange}
                              isEditUser={true}
                            />
                          </div>
                          {displaySupplierSearch &&<H5 className=" ncss-col-sm-3 u-bold description p2-top-sm p2-bottom-sm">PCX Supplier</H5>}
                          {displaySupplierSearch &&<div className="ncss-col-sm-9"> <Field component={TextInput} name="supplierName" type="text" disabled /></div>}
                          {/* <Field component={TextInput} name="supplierOrLocationId" type="hidden" /> */}

                        </div>
                       
                        </> :
                        <span>
                          {
                            displayLab ?
                              <div className="ncss-col-sm-12 ncss-input-container ">
                                <H5 className="ncss-col-sm-3 u-bold description p2-top-sm p2-bottom-sm">Lab Country</H5>
                                <div className="ncss-col-sm-9">
                                  <span className="dropdown-add-supplier">
                                    <Field
                                      component={DropDown}
                                      name="country"
                                      placeholder="Select a Country"
                                      options={getCountryOptions(labLocationCountries)}
                                      className="lab-country-dropdown"
                                      onOptionSelect={this.onCountryChange}
                                      scrollable
                                      menuMaxHeight={220}
                                    />
                                  </span>
                                </div>
                                <div>
                                  <H5 className="ncss-col-sm-3 u-bold description p2-top-sm p2-bottom-sm">Lab Location</H5>
                                  <div className="ncss-col-sm-9">
                                    <span className="dropdown-add-supplier">
                                      <Field
                                        component={DropDown}
                                        name="labLocationId"
                                        placeholder="Select a Lab Location"
                                        options={getLabLocations(
                                          labLocationCountries,
                                          editUserProfileStates && editUserProfileStates.country
                                        )}
                                        className="dropdown-border ie-border-padding-0-fix"
                                        disabled={!(editUserProfileStates && editUserProfileStates.country)}
                                        onOptionSelect={this.onLabLocationChange}
                                      />
                                    </span>
                                  </div>
                                </div>
                              </div> : null}
                        </span>
                    }

                    <div className="ncss-col-sm-12 ncss-input-container ">
                      <H5 className=" ncss-col-sm-3 u-bold description p2-top-sm p2-bottom-sm">Phone</H5>
                      <div className="ncss-col-sm-9"><Field component={TextInput} name="contact" type="text" /></div>
                    </div>
                    {(displayFactory || displaySupplier) && !isAdd &&
                       <div className="ncss-col-sm-12 ncss-input-container p2-top-sm p2-bottom-sm">
                       <H5 className=" ncss-col-sm-3 u-bold description p2-top-sm p2-bottom-sm"> OS ID Search</H5>
                       <div className="ncss-col-sm-9">
                         <SupplierSearch
                           isOSIdSearch={true}
                           includeInternal={true}
                           requsetLocation={false}
                           osIdChange = { this.onOSIdChange}
                           filteredSupp={oshIdArr}
                         />
                       </div>
                       </div>
                       }
                    {(displayFactory || displaySupplier) && !isAdd &&<div className="ncss-col-sm-12 ncss-input-container ">
                      
                      {oshIdArr.map((item,i)=>{
                        return(
                          oshIdArr[i].OSId !== null && <div>
                          {i === 0 ? <H5 className=" ncss-col-sm-3 u-bold description p2-top-sm p2-bottom-sm">Other OS ID</H5>:
                          <div className=" ncss-col-sm-3"></div>} 
                          <div className="ncss-col-sm-5">
                          <input
                          className="ncss-input p2-top-sm pt2-sm pr4-sm pb2-sm pl4-sm"
                          placeholder="Enter OSID"
                          onChange={(e) => this.handleOSHIDChange(e, i)}
                            value={oshIdArr[i].OSId}
                            id={i}
                            type="text"
                            disabled
                          /></div>
                          <div className="ncss-col-sm-3 ncss-input-container">
                          <Button className=" ncss-col-sm-3 u-bold pb1-sm addmore-error" style={{backgroundColor:"white"}} onClick={() => this.handleRemoveClick(i)}>
                            Remove
                          </Button>
                     </div> 
                          </div>
                        )
                      
                        })}
                        </div>
                        }
                        {
                        (displayFactory || displaySupplier) && !isAdd ?
                        <div className="ncss-col-sm-12 ncss-input-container ">
                          <div className="p2-sm">
                          <H4 className="text-color-accent u-bold">CHECKLISTS</H4>
                          </div>
                          <div className="ncss-col-sm-12 ncss-input-container ">
                          <H5 className="ncss-col-sm-3 u-bold description p2-top-sm p2-bottom-sm margin-left-neg-9" >OSH Completed</H5>
                          <input type="checkbox" name ="oshCompleted"  
                          disabled={oshStatus}
                          checked={oshStatus || oshUpdate}
                          onChange ={ e =>this.handleOSH(e)}
                          className='cursor-pointer-margin-left'
                          />
                          {showOsIdError && <div className='ncss-col-sm-8 u-bold color-red-margin-left'>There is no OS ID for this user.</div>}
                          {(!isAdd && osIdState !== '') &&
                          <><H5 className=" ncss-col-sm-1 u-bold description p2-top-sm p2-bottom-sm">OS ID</H5>
                          <H5 className='ncss-col-sm-3'>{osIdState}</H5>
                          <i className="fas fa-trash" onClick={() => this.handleDeleteOsId(osIdState)}/>
                          </>
                          }
                          </div>
                          <div className='ncss-col-sm-12 ncss-input-container'>
                          <H5 className="ncss-col-sm-3 u-bold description p2-top-sm p2-bottom-sm margin-left-neg-9">Training Completed {litmosUpdate}</H5>
                           
                          <input
                          className='cursor-pointer-margin-left'
                           type="checkbox"
                          name="litmos"
                          disabled={
                          editUserProfileStates &&
                          editUserProfileStates.litmosStatus === "completed" &&
                          !isDeletedFiles.length
                          }
                          checked={
                          editUserProfileStates &&
                          editUserProfileStates.litmosStatus === "completed" &&
                          !isDeletedFiles.length &&
                          litmosCheckboxstate === false
                            ? true
                            : litmosCheckboxstate === true
                            ? true
                            : getLitmosCheckboxValue
                          }
                          onChange={e => this.handleLitmos(e)}
                          />
                          {showLitmosError && <div className='ncss-col-sm-8 u-bold color-red-margin-left'>There is no Training Certificate to complete the training.</div>}

                          {((editUserProfileStates.litmos && editUserProfileStates.litmos.attachmentData && 
                         editUserProfileStates.litmos.attachmentData.length > 0) || 
                        (trainingCerAttachments && trainingCerAttachments.length > 0)) && 
                        <H5 className="ncss-col-sm-3 u-bold description p2-top-sm p2-bottom-sm">Training Certificates</H5>
                        }
                          {trainingCerAttachments && trainingCerAttachments.map((item, i) => {
                                const fileName = typeof item === 'object' && item !== null ? 
                                  (item.fileName || (item.attachmentName ? item.attachmentName : '')) : 
                                  (typeof item === 'string' ? item : '');
                                return (
                                    <div key={`prev-attachment-${i}-${fileName}`}  className='displayFlex padTop12'>
                                      <div className="ncss-col-sm-4"></div>
                                      <div className="ncss-col-sm-8 commentStyle">
                                        <H5 className="u-bold description padding-left-14 font-size-12">
                                          {fileName || 'Unnamed file'}
                                        </H5>
                                      </div>
                                      <div className="ncss-col-sm-4">
                                        <div className="ncss-col-sm-1 padRight20">
                                          <i className="fas fa-eye" alt="Preview" 
                                             onClick={() => this.previewFile({ 
                                               id: editUserProfileStates.litmos.id, 
                                               fileName: fileName 
                                             })} 
                                          />
                                        </div>
                                        <div className="ncss-col-sm-1 padRight20" 
                                             onClick={() => this.openConfirmationPopup(fileName)}>
                                          <i className='fa fa-download download-fontSize' alt="Download" />
                                        </div>
                                        <div className="ncss-col-sm-1 padRight20" >
                                          <i className="fas fa-trash" 
                                             onClick={() => this.handleDelete(i)} 
                                          />
                                        </div>
                                      </div>
                                    </div>
                                );
                            })}
                        </div>
                        <div className='ncss-col-sm-12 ncss-input-container'>
                          <H5 className="ncss-col-sm-3 u-bold description p2-top-sm p2-bottom-sm margin-left-neg-9">Training Material Completed</H5>
                          <input
                            className='cursor-pointer-margin-left'
                            type="checkbox"
                            name="trainingMaterial"
                            disabled={true}
                            checked={trainingMaterialStatus}
                          />
                          {trainingMaterialStatus && (
                            <i className="fas fa-trash cursor-pointer-margin-left" 
                               onClick={() => this.handleDeleteTrainingMaterial()} 
                               title="Reset Training Material status to pending"
                            />
                          )}
                          {trainingMaterialDeleted && (
                            <span className="ncss-col-sm-6 u-bold color-red-margin-left">
                              Training Material will be reset to pending on save
                            </span>
                          )}
                        </div>
                        </div>
                        : null
                    }
                  </div>
                  <div className="ncss-col-sm-12 ">
                    <div className="bottom-section p4-top-sm">
                      <Button
                        className="ncss-btn-secondary-dark u-bold secondary-button trf-button-selected"
                        onClick={() => { this.toggleModal(false); clearUserDetailsFilled() }}
                      >
                        CANCEL
                      </Button>
                      {editUserProfileStates &&
                        editUserProfileStates.companyName &&
                        editUserProfileStates.phone ?
                        <span>
                          {isAdd ?
                            <Button className="ncss-btn-primary-dark u-bold submit-button-enable new-material"
                              onClick={() => { this.submitAddUserData() }}
                            >
                              SUBMIT
                            </Button> :
                            <Button className="ncss-btn-primary-dark u-bold submit-button-enable new-material"
                              onClick={() => { this.updateAddUserData(); clearUserDetailsFilled(); toggleModal(false); }}
                            >
                              UPDATE 
                            </Button>}
                        </span> :
                        <span>
                          {isAdd ?
                            <Button
                              className={`ncss-btn-primary-dark u-bold submit-button-enable trf-button-selected ${!this.shouldEnableSubmit() ? 'disabled' : ''
                                }`}
                              {...this.shouldEnableSubmit() && { onClick: () => { this.submitAddUserData(); toggleModal(false); clearUserDetailsFilled() } }}
                            >
                              SUBMIT
                            </Button>
                            :
                            <Button
                              className={`ncss-btn-primary-dark u-bold submit-button-enable trf-button-selected  ${!this.shouldEnableUpdate() ? 'disabled' : ''}`}

                              onClick={() => { this.updateAddUserData(); clearUserDetailsFilled(); toggleModal(false); }}
                            >
                              UPDATE
                            </Button>
                          }
                        </span>
                      }
                    </div>
                  </div>
                </div>
                <ConfirmationBox
                  message={
                    `Do you want to download the file ${selectedFileName}?`
                  }
                  submitModal={submitModal}
                  submitValue={
                    () => {
                      this.downloadFile({ id: editUserProfileStates.litmos.id, fileName: selectedFileName });
                    }
                  }
                  closeModal={this.closeSubmitModal}
                />
                {osIdModalOpen === true &&
                 <ConfirmationBox
                  message={`Are you sure you want to Delete the OSID?`}
                  submitModal={osIdModalOpen}
                  submitValue={() => {
                    this.onHandleOkDeleteOshId(editUserProfileStates.OSHId)
                    }}
                    closeModal={this.closeSubmitModal}
                  />}
                  {trainingCerModalOpen === true &&
                   <ConfirmationBox
                    message={`Are you sure, you want to Delete the Training Certificate - ${isSelectedFile}?`}
                    submitModal={trainingCerModalOpen}
                    submitValue={() => {
                    this.handleDeleteTrainingCertificate(isSelectedFile,isSelectedFileID);
                  }}
                  closeModal={this.closeSubmitModal}
                />}
                {trainingMaterialModalOpen === true &&
                  <ConfirmationBox
                    message={`Are you sure you want to reset the Training Material status to pending?`}
                    submitModal={trainingMaterialModalOpen}
                    submitValue={() => {
                      this.onHandleOkDeleteTrainingMaterial();
                    }}
                    closeModal={this.closeSubmitModal}
                  />}
              </form>
              {selectedFile !== null &&
              <Modal
                            isOpen={modalIsOpen}
                            onRequestClose={this.closeModal}
                            contentLabel="File Preview"
                            overlayClassName="modal-overlay"
                        >
                            <IconButton icon="times" className="modal-close-btn" onClick={this.closeModal} />
                             {previewSpinner && <Spinner large /> }
                             {!previewSpinner && <PdfPreview file={selectedFile ? selectedFile : ''} />}
                            <button onClick={this.closeModal}>Close</button>
                        </Modal>
         }
            </Modal>
        }
      </span>
    );
  }
}

EditUserProfile.propTypes = {
  isModalOpen: PropTypes.bool,
  toggleModal: PropTypes.func,
  clearUserDetailsFilled: PropTypes.func,
  isAdd: PropTypes.bool,
  editUserProfileStates: PropTypes.object,
  getLitmosCheckboxValue: PropTypes.bool,
};
EditUserProfile.defaultProps = {
  isAdd: true
};

const mapStateToProps = state => {
  let litmosCheckBoxValue = false;
  try {
    if (state.navigation && typeof state.navigation.get === 'function') {
      litmosCheckBoxValue = state.navigation.get('litmosCheckBoxValue') || false;
    } 
    else if (state.navigation && typeof state.navigation === 'object') {
      litmosCheckBoxValue = state.navigation.litmosCheckBoxValue || false;
    }
  } catch (error) {
    console.error("Error accessing litmosCheckBoxValue:", error);
  }
  
  return {
    editUserProfileStates: getFormValues('editUserProfile')(state) || {OSIds:[],OSHId:''},
    supplierStates: getFormValues('supplierForm')(state),
    supplierList: getSupplierList(state),
    labLocationCountries: state.trf.labLocationCountries,
    labLocationsLoading: state.trf.labLocationsLoading,
    previewAttachmentData: state.previewAttachment.previewAttachmentData,
    getLitmosCheckboxValue: litmosCheckBoxValue,
  };
};

const mapDispatchToProps = dispatch => ({
  updateUserData: (data) => {
    dispatch(createServiceAction('editUserProfile', 'updated')(data));
  },
  clearUserDetailsFilled: () => {
    const forms = ['editUserProfile'];
    forms.map(form => dispatch(reset(form)));
  },
  submitUserProfile: data => {
    dispatch(createServiceAction('addUserProfile', 'requested')({ formValues: data }));
  },
  updateUserProfile: data => {
    dispatch(createServiceAction('updateUserProfile', 'requested')(data));
  },
  toggleAddSupplerButton: () => {
    dispatch(toggleAddSupplerButton());
  },
  downloadAttachment: data => {
    dispatch(createServiceAction('downloadAttachment', 'requested')(data));
  },
  previewAttachment: data => {
    dispatch(createServiceAction('previewAttachment', 'requested')(data));
  },
  litmosCheckBoxValue: data => {
    dispatch(litmosCheckBoxValue(data));
  }
});

export default reduxForm({ form: 'editUserProfile',initialValues: {
  OSIds:[],
  OSHId:''
}, enableReinitialize: true})(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(EditUserProfile));